import moment from 'moment';
import 'moment-duration-format';

/**
 * Renders a duration given in total minutes as `HH:mm`.
 *
 * Goes through `moment-duration-format` rather than `moment.utc(...).format()`, which
 * wraps at 24 hours — 1500 minutes has to read as `25:00`, not `01:00`.
 *
 * @param minutes the duration in total minutes
 * @returns the duration as `HH:mm`
 */
export function formatDurationMinutes(minutes: number): string {
    return moment.duration(minutes, 'minutes').format('HH:mm', { trim: false });
}
